import { render } from "./EmailWithCurrentPassword.vue?vue&type=template&id=bbf3ac5a&scoped=true&ts=true"
import script from "./EmailWithCurrentPassword.vue?vue&type=script&lang=ts"
export * from "./EmailWithCurrentPassword.vue?vue&type=script&lang=ts"

import "./EmailWithCurrentPassword.vue?vue&type=style&index=0&id=bbf3ac5a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf3ac5a"]])

export default __exports__